import React from 'react';
import { Flex, Text } from 'core/components';
import DeprecatedTag from 'app/components/DeprecatedTag';
import SudoTag from 'app/components/SudoTag';

// ai-gateway model visibility; internal models only reach sudo users
export const MODEL_VISIBILITY_TAGS = { internal: SudoTag, deprecated: DeprecatedTag };

type ModelVisibility = keyof typeof MODEL_VISIBILITY_TAGS;

interface ModelVisibilityLabelProps {
  name: string;
  visibility: ModelVisibility;
}

// the tag is right-aligned in both the select menu and the select button
const ModelVisibilityLabel = ({ name, visibility }: ModelVisibilityLabelProps) => {
  const VisibilityTag = MODEL_VISIBILITY_TAGS[visibility];

  return (
    <Flex alignItems="center" justifyContent="space-between" gap="6px" width="100%" minWidth={0}>
      <Text ellipsis>{name}</Text>
      <VisibilityTag small flex="none" />
    </Flex>
  );
};

export default ModelVisibilityLabel;
